import { CtaButton } from "@/components/site/CtaButton";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page">
      <Seo title="Payment Cancelled | The AI Doctor" description="No charge was made — your checkup is still available whenever you're ready." />
      <section className="shell min-h-screen flex flex-col justify-center py-40">
        <span className="eyebrow">Payment Cancelled</span>
        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-medium text-[#f5f3ee] max-w-3xl">
          Cold feet at the till?
        </h1>
        <p className="mt-6 text-base md:text-lg text-[#a7a7a2] max-w-xl leading-relaxed">
          No charge was made. Your checkup is still available whenever you're ready —
          the symptoms aren't going anywhere on their own.
        </p>
        <div className="mt-10 flex gap-4 flex-wrap">
          <CtaButton to="/book-checkup" testid="cancel-retry-button">Back to booking</CtaButton>
          <CtaButton to="/" variant="ghost" testid="cancel-home-button">Back to the clinic</CtaButton>
        </div>
      </section>
    </div>
  );
}
